import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  background-color: ${props => props.theme.colors.card};
  grid-area: CardSecondary;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  border-radius: 10px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  padding: clamp(1.25rem, 2.5vw, 1.875rem);
  gap: clamp(0.25rem, 0.5vw, 0.3125rem);
  
  @media (max-width: 576px) {
    flex-direction: column;
    padding: clamp(1rem, 2vw, 1.25rem);
    gap: 0.75rem;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: clamp(0.25rem, 0.5vw, 0.3125rem);
`;

export const TextContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    gap: clamp(0.5rem, 1vw, 0.75rem);
`;

export const Title = styled.span`
  color: ${props => props.theme.colors.primary};
  font-weight: 600;
  font-size: clamp(0.875rem, 1.2vw, 1rem);
`;

export const Value = styled.h2`
  color: ${props => props.theme.colors.text};
  font-size: clamp(1.25rem, 2vw, 1.375rem);
`;

export const SubTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: clamp(0.25rem, 0.5vw, 0.3125rem);
`;

export const Subtitle = styled.span`
  color: ${props => props.theme.colors.primary};
  font-size: clamp(0.75rem, 1vw, 0.875rem);
`;

export const SecondaryValue = styled.span`
  color: ${props => props.theme.colors.text};
  font-weight: 600;
  font-size: clamp(0.875rem, 1.2vw, 1rem);
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
`;